import React from 'react';
import { TranslationFunction } from '../../types';

interface ScheduleModalWrapperProps {
  title: string;
  onClose: () => void;
  onSave: () => void;
  children: React.ReactNode;
  t: TranslationFunction;
}

export const ScheduleModalWrapper: React.FC<ScheduleModalWrapperProps> = ({ title, onClose, onSave, children, t }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50 print:hidden">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] flex flex-col">
        <div className="flex justify-between items-center p-4 border-b">
          <h3 className="text-xl font-semibold text-[#1a2c46]">{title}</h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label={t('close_schedule_button')}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-grow">
          {children}
        </div>
        <div className="flex justify-end items-center p-4 border-t space-x-3">
           <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-[#1a2c46] font-semibold py-2 px-4 rounded shadow-sm transition duration-150"
          >
            {t('close_schedule_button')}
          </button>
          <button
            onClick={onSave}
            className="bg-[#b98e4c] hover:bg-[#a37d40] text-[#1a2c46] font-semibold py-2 px-4 rounded shadow-sm transition duration-150"
          >
            {t('save_schedule_button')}
          </button>
        </div>
      </div>
    </div>
  );
};